import { useTranslations } from "use-intl";
import type { PaymentMethod } from "@/app/lib/payments/types";

interface Props {
  totalPrice: string;
  paymentMethod: PaymentMethod;
}

export const PaymentDetails = ({ totalPrice, paymentMethod }: Props) => {
  const t = useTranslations();

  const getPaymentMethodLabel = (method: PaymentMethod) => {
    switch (method) {
      case "checkout":
        return t("debitCard");
      case "qiAccount":
        return t("qiCard");
      case "bnpl":
        return t("payLater");
      default:
        return t("debitCard");
    }
  };

  return (
    <div className="section-card mt-2 flex flex-col gap-2 text-sm">
      <div className="flex justify-between">
        <div className="text-text-tertiary">{t("total")}</div>
        <div className="font-bold text-text-primary">{totalPrice}</div>
      </div>
      <div className="flex justify-between">
        <div className="text-text-tertiary">{t("paymentMethod")}</div>
        <div className="font-bold text-text-primary">
          {getPaymentMethodLabel(paymentMethod)}
        </div>
      </div>
    </div>
  );
};
